import React, { Component } from "react";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import LightBox from "../../../ui/LightBox";
import { generateFileUrl } from "../../../../apiHelper";
import { apiBaseUrl } from "../../../../config";
import { populateFormDataFromListing } from "../helpers";
import { updateFormData, updateListingPhotos } from "../actions";
import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
  EmailIcon,
} from "react-share";
import EmailOptionsModal from "../../../listings/email-options-modal";
import { getUserProfileInfo } from "../../../user/actions";
import { ListingFormSteps } from "../constants";
import { PHOTO_PLACEHOLDER } from "../../../../constants/images";

const mapStateToProps = (state) => ({
  user: state.User,
});

class ListingDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      shareModalOpen: false,
    };

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openModal() {
    this.setState({ shareModalOpen: true });
  }

  closeModal() {
    this.setState({ shareModalOpen: false });
  }

  componentWillMount() {
    let { dispatch, global } = this.props;
    dispatch(getUserProfileInfo(global.userId));
  }

  getLightBoxImages = () => {
    let images = [];
    let id = this.props.listing._id;
    let listingPhotos = this.props.listing.photos;
    if (listingPhotos && listingPhotos.length > 0) {
      listingPhotos.map((x) => {
        const src = !!this.props.listing.streamId ? x : generateFileUrl(x, id);
        images.push({
          src: src,
          height: 4,
          width: 8,
          original: src,
        });
      });
    }
    return images;
  };

  getDefaultImage = () => {
    return "/public/img/Photo-Placeholder.png";
  };

  editDetails = () => {
    let { history, dispatch } = this.props;
    let formData = populateFormDataFromListing(this.props.listing);
    dispatch(updateFormData(formData));
    history.push("/dashboard/listing/edit/details");
  };

  completeListing(lastCompleted) {
    let { history, dispatch } = this.props;
    let formData = populateFormDataFromListing(this.props.listing);
    let stepName = ListingFormSteps.find(
      (lfs) => lfs.step === lastCompleted
    ).name;
    dispatch(updateFormData(formData));
    history.push("/dashboard/listing/forms/" + stepName);
  }

  editPhotos = () => {
    let { history, dispatch } = this.props;
    let formData = populateFormDataFromListing(this.props.listing);
    dispatch(updateFormData(formData));
    let photoPreviews = formData.photos.map((x) => ({
      name: x,
      preview: !!this.props.listing.streamId
        ? x
        : generateFileUrl(x, formData.id),
    }));
    dispatch(updateListingPhotos(photoPreviews));
    history.push("/dashboard/listing/edit/photos");
  };

  renderShareModal() {
    let { user, listing } = this.props;
    return (
      <EmailOptionsModal
        onClose={this.closeModal}
        values={{
          currentUser: user.user,
          listingId: listing._id,
          exportLink:
            "https://collegeweekends.com/app/#/listing/" + listing._id,
        }}
      />
    );
  }

  render() {
    let { listing, toggleIsActive, listingCompleted } = this.props;
    let images = this.getLightBoxImages();
    if (!images.length) {
      images = [
        {
          src: PHOTO_PLACEHOLDER,
          height: 4,
          width: 8,
          original: PHOTO_PLACEHOLDER,
        },
      ];
    }
    let defaultImage = images[0].src;

    return (
      <div className="listing-details row">
        <div className="col-12 col-lg-6 photo-gallery-column">
          <div className="row ml-0 mr-0 image-container">
            <LightBox defaultImage={defaultImage} images={images} carousel />
          </div>
          {listingCompleted && (
            <div className="row">
              <button
                type="button"
                className="btn-secondary mx-auto mt-3 mb-3"
                onClick={this.editPhotos}
              >
                Manage Photos
              </button>
            </div>
          )}
          <div className="row">
            <p>{listing.listingDetails.about}</p>
          </div>
        </div>
        <div className="col-12 col-md-6 col-lg-3">
          <div className="mb-3">
            <span className="marker">
              <i className="fas fa-map-marker-alt"></i> {listing.address.city},{" "}
              {listing.address.state}
            </span>
            <a target="_blank" href={`/app/#/listing/${listing._id}`}>
              <h2>{listing.listingName}</h2>
            </a>
            <span className="listing-type">
              {listing.houseType} | sleeps {listing.sleeps}
            </span>
          </div>
          {listingCompleted && (
            <div className="mb-3">
              <div className="toggle-active">
                <div className="d-inline-flex">
                  <strong>Active</strong>
                </div>
                <label className="switch align-top ml-2">
                  <input
                    type="checkbox"
                    checked={listing.isActive}
                    onChange={toggleIsActive}
                  />
                  <span className="slider round"></span>
                </label>
              </div>
              <div className="d-flex align-items-center mb-3">
                <div className="">
                  <FacebookShareButton
                    className="social-button"
                    url={`${window.location.origin}${apiBaseUrl}/share/${listing._id}`}
                    quote="Check out this listing on CollegeWeekends.com!"
                  >
                    <FacebookIcon size={32} round />
                  </FacebookShareButton>
                </div>
                <div className="ml-3">
                  <TwitterShareButton
                    className="social-button"
                    url={`${window.location.origin}${apiBaseUrl}/share/${listing._id}`}
                    title="Check out this listing on CollegeWeekends.com!"
                  >
                    <TwitterIcon size={32} round />
                  </TwitterShareButton>
                </div>
                <div className="ml-3">
                  <button
                    className="btn btn-circle"
                    onClick={() => {
                      this.openModal("share");
                    }}
                  >
                    <EmailIcon size={32} round />
                  </button>
                </div>
              </div>
            </div>
          )}
          <div className="mb-3">
            <div>
              <strong># of Bedrooms:</strong> {listing.bedrooms}
            </div>
            <div>
              <strong># of Bathrooms:</strong> {listing.bathrooms}
            </div>
            {listing.bookingSetting !== "" && (
              <div>
                <strong>Booking Setting:</strong> {listing.bookingSetting}
              </div>
            )}
          </div>
          {listing.listingDetails.sleepingArrangements !== "" && (
            <div className="mb-3">
              <div>
                <h6>Sleeping Arrangements</h6>
                <div>{listing.listingDetails.sleepingArrangements}</div>
              </div>
            </div>
          )}
          <div className="mb-3">
            <h6>Host Rules</h6>
            <li>
              {listing.listingDetails.petsAllowed ? "Pet-Friendly" : "No Pets"}
            </li>
            <li>
              {listing.listingDetails.smokingAllowed
                ? "Smoking Permitted"
                : "No Smoking"}
            </li>
          </div>
        </div>
        <div className="col-12 col-md-6 col-lg-3">
          {listingCompleted ? (
            <button
              type="button"
              className="btn-primary mb-3"
              onClick={this.editDetails}
            >
              Edit Details
            </button>
          ) : (
            <button
              type="button"
              className="btn-primary mb-3 btn-edit-continue"
              onClick={() => this.completeListing(listing.lastCompleted)}
            >
              Continue Editing &amp; Publish
            </button>
          )}

          {listing.amenities.length > 0 && (
            <div>
              <h6>Amenities</h6>
              {listing.amenities.map((name, index) => {
                return <li key={index}>{name}</li>;
              })}
            </div>
          )}
        </div>
        {this.state.shareModalOpen && this.renderShareModal()}
      </div>
    );
  }
}

export default withRouter(connect(mapStateToProps)(ListingDetails));
